import Konva from 'konva'
import { status, statusColors } from '@/views/EquipmentManager/constants'

const WIDTH = 212
const defaultContent = {
  key: '#KEY',
  value: '#VALUE',
  unit: '#UNIT'
}
const BG_WIDTH = 170
const BG_HEIGHT = 18
const DEFAULT_COLOR = '#fff'
const PADDING = 4
const GAP = 30

export function loadDataBlock (stage, addNodeEvent = (node) => {}) {
  stage.find('.dataBlock').forEach(block => {
    const header = block.findOne('.dataBlockHeader')
    if (!header) return
    addNodeEvent(header)
    addNodeEvent(header.findOne('.dataBlockTitle'))
    const body = block.findOne('.dataBlockBody')
    header.dragBoundFunc(pos => {
      block.absolutePosition(pos)
      return body.absolutePosition()
    })
    addNodeEvent(block)
  })
}

export function createDataBlock (position, addNodeEvent = node => {}) {
  const group = new Konva.Group({
    name: 'dataBlock',
    x: position.x,
    y: position.y
  })
  const header = createHeader({ x: 0, y: 0 }, addNodeEvent)
  const body = createBody()
  group.add(body, header)
  addNodeEvent(header)
  header.dragBoundFunc(pos => {
    group.absolutePosition(pos)
    return body.absolutePosition()
  })
  return group
}

function createHeader (position = { x: 0, y: 0 }, addNodeEvent = node => {}) {
  const header = new Konva.Group({
    name: 'dataBlockHeader',
    x: position.x,
    y: position.y
  })
  const bg = new Konva.Rect({
    name: 'dataBlockHeaderBackground',
    x: 0,
    y: 0,
    fill: statusColors.online,
    opacity: 1,
    cornerRadius: [5, 5, 0, 0],
    width: WIDTH,
    height: 30
  })
  const title = new Konva.Text({
    name: 'dataBlockTitle',
    x: 10,
    y: 10,
    text: '#DEVICE',
    fill: '#fff',
    fontSize: 15
  })
  addNodeEvent(title)
  header.add(bg, title)
  return header
}

function createBody (position = { x: 0, y: 0 }) {
  const body = new Konva.Rect({
    name: 'dataBlockBody',
    x: position.x,
    y: position.y,
    fill: 'rgba(14, 51, 99, 0.54)',
    cornerRadius: [5, 5, 5, 5],
    width: WIDTH,
    height: 70
  })
  return body
}

export function updateHeaderTag (block, tags) {
  if (!tags[0]) {
    return
  }
  removeBlockHeaderTag(block)
  tags.sort((a, b) => a.priority - b.priority)
  addBlockHeaderTag(block, tags)
  const item = status.find(s => s.key === tags[0].value)
  if (item) {
    block.findOne('.dataBlockHeaderBackground').fill(item.color)
  }
}

function removeBlockHeaderTag (block) {
  block.find('.statusTag').forEach(tag => {
    tag.destroy()
  })
}

function addBlockHeaderTag (block, tags) {
  const header = block.findOne('.dataBlockHeader')
  const title = block.findOne('.dataBlockTitle')
  const bg = header.findOne('.dataBlockHeaderBackground')
  const tag = title.clone()
  const cr = bg.getClientRect({
    relativeTo: block
  })
  if (tags[0]?.text) {
    tag.text(tags[0].text)
  }
  const tagRect = tag.getClientRect({
    relativeTo: block
  })
  tag.x(cr.width - (tagRect.width + title.x()))
  tag.name('statusTag')
  tag.fill('#fff')
  header.add(tag)
}

export function createMonitorBlock (position, addNodeEvent = node => {}) {
  const group = new Konva.Group({
    name: 'monitorBlock',
    x: position.x,
    y: position.y
  })
  const header = createHeader({ x: 0, y: 0 }, addNodeEvent)
  const body = createBody()
  const row = new Konva.Group({
    name: 'monitorRow',
    x: 10,
    y: 40
  })
  const bg = new Konva.Rect({
    name: 'background',
    x: 0,
    y: 0,
    width: BG_WIDTH,
    height: BG_HEIGHT,
    // fill: 'rgba(249,240,255,0.25)',
    cornerRadius: 3,
    draggable: false
  })
  const key = new Konva.Text({
    name: 'monitorKey',
    x: bg.x() + PADDING,
    y: bg.y() + PADDING,
    text: defaultContent.key,
    fill: DEFAULT_COLOR,
    fontSize: 15
  })
  const value = new Konva.Text({
    name: 'monitorValue',
    x: key.x() + key.width() + GAP,
    y: key.y(),
    text: defaultContent.value,
    fill: '#3FFFFF',
    fontSize: 15
  })
  const unit = new Konva.Text({
    name: 'monitorUnit',
    x: value.x() + value.width() + GAP,
    y: key.y(),
    text: defaultContent.unit,
    fill: DEFAULT_COLOR,
    fontSize: 15
  })
  row.add(bg, key, value, unit)
  addNodeEvent(key)
  addNodeEvent(value)
  addNodeEvent(unit)
  addNodeEvent(row)
  group.add(body, header, row)
  header.dragBoundFunc(pos => {
    group.absolutePosition(pos)
    return body.absolutePosition()
  })
  return group
}

export function loadMonitorBlock (stage, addNodeEvent = (node) => {}) {
  stage.find('.monitorBlock').forEach(block => {
    const header = block.findOne('.dataBlockHeader')
    if (!header) return
    // addNodeEvent(header)
    addNodeEvent(header.findOne('.dataBlockTitle'))
    addNodeEvent(block.findOne('.monitorKey'))
    addNodeEvent(block.findOne('.monitorValue'))
    addNodeEvent(block.findOne('.monitorUnit'))
    const body = block.findOne('.dataBlockBody')
    header.dragBoundFunc(pos => {
      block.absolutePosition(pos)
      return body.absolutePosition()
    })
    addNodeEvent(block)
  })
}